export default __webpack_public_path__ + "eff9b48089d0e457f235e5a1cef48efd.png";